
import { useState, useRef, useEffect } from 'react';

interface Language {
  code: string;
  label: string;
  flag: string;
  path: string;
}

const languages: Language[] = [
  { code: 'ru', label: 'Рус', flag: '🇷🇺', path: '/home-b' },
  { code: 'kz', label: 'Қаз', flag: '🇰🇿', path: '/kz' },
];

export default function LanguageSwitcher() {
  const [isOpen, setIsOpen] = useState(false);
  const [current, setCurrent] = useState<Language>(languages[0]);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLanguageChange = (lang: Language) => {
    setCurrent(lang);
    setIsOpen(false);
    
    if (window.REACT_APP_NAVIGATE) {
      try {
        window.REACT_APP_NAVIGATE(lang.path);
      } catch (err) {
        console.error('Navigation error:', err);
      }
    }
  };

  return (
    <div ref={dropdownRef} className="relative z-50">
      {/* Language switcher button removed */}

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 min-w-[120px] bg-white/95 backdrop-blur-xl border border-white/20 rounded-xl shadow-2xl overflow-hidden animate-fade-in">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang)}
              className={`w-full flex items-center space-x-2.5 px-4 py-3 text-left transition-all duration-200 ${
                current.code === lang.code
                  ? 'bg-[#0360cd]/10 text-[#0360cd]'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <span className="text-sm leading-none">{lang.flag}</span>
              <span className="text-sm font-medium">{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
